import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { ApiService, AlertService } from '../../_services';
import { VerifyMemberInfo } from '../../_models/verify-member-info';
import { DependentService } from '../../_services/dependent.service';

@Component({
  selector: 'app-register-dependent',
  templateUrl: './register-dependent.component.html',
  styleUrls: ['./register-dependent.component.scss']
})
export class RegisterDependentComponent implements OnInit {

  registerForm: FormGroup;
  submitted = false;
  loading = false;
  isMemberVerified: boolean = false;
  verifyMemberInfo: VerifyMemberInfo;
  username = '';
  verificationid ="";

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private apiService: ApiService,
    private activatedRoute: ActivatedRoute,
    private dependentService : DependentService,
    private alertService : AlertService,
  ) {
    this.verifyMemberInfo = new VerifyMemberInfo();


        this.verificationid = this.activatedRoute.snapshot.queryParams.verificationid;

   }

  ngOnInit() {
    this.registerForm = this.formBuilder.group({
      username: ['',Validators.required],
      password: [''],
      confirmPassword: ['', Validators.required]
    }, {

    })
    this.dependentService.getDependentVerified(this.verificationid).subscribe(r=>{
      this.username = r.username;
    console.log(r)
    this.registerForm.controls["username"].setValue(this.username)
  })
  }

  get f() { return this.registerForm.controls; }


  onSubmit(){
    this.submitted = true;
    //
    //this.registerForm.value.memberId = this.verifyMemberInfo.memberId;
    // stop here if form is invalid
    if (this.registerForm.invalid) {
        return;
    }

    this.loading = true;

    this.dependentService.verifyAndCreatePassword(this.verificationid,this.registerForm.value)
        .subscribe(
            data => {
                this.alertService.success('Registration Dependent Account successfully.', true);
                this.router.navigate(['/login']);
            },
            err => {
                this.alertService.error(err.error);
                this.loading = false;
            });
  }

}



// WEBPACK FOOTER //
// ./src/app/register/register-dependent/register-dependent.component.ts